import React, { useMemo } from "react";
import axios from "../../api/axios";
import "./ViewContractModal.css";

import { useState, useRef } from "react";
import NCALayerModal from "../../components/NCALayerModal";
import { ensureNCALayerConnected } from "../../utils/ensureNCALayer";


export default function ViewContractModal({
  selectedContract,
  setSelectedContract,
  profile,
  token,
  locale = "kz",
  openContractView,
  onClose,
}) {
  /* ================= i18n ================= */
  const t = {
    kz: {
      title: "Келісімшарт қарау",
      expert: "Сарапшы",
      status: "Күйі",
      signedStatus: "✅ Қол қойылды",
      pendingStatus: "⏳ Күтілуде",
      signFlow: "Қол қою реті",
      contractNumber: "Келісім шарт нөмірі:",
      date: "Күні:",
      save: "Нөмір мен күнді сақтау",
      sign: "Қол қою (ЭЦҚ)",
      previewPdf: "PDF көру",
      download: "Құжатты жүктеу (DOCX)",
      error: "❌ Нөмір қою кезінде қате шықты",
      downloadError: "❌ Құжатты жүктеу сәтсіз",
      applicationsTitle: "📚 Өтінімдер",
      roles: {
        internal_expert: "Ішкі сарапшы",
        department_head: "Бөлім басшысы",
        deputy_director_2: "Директордың орынбасары",
        registrar: "Тіркеуші",
        accountant: "moderator_accountant",
        director: "Директор",
        external_expert: "Сыртқы сарапшы",
        goszakup: "Мемлекеттік сатып алулар маманы",
      },
      tableHeaders: { role: "Рөлі", user: "Пайдаланушы", status: "Күйі", date: "Күні" },
      statusValues: { draft: "Жобада", signed: "Қол қойылды", rejected: "Қабылданбады", in_progress: "Өңделуде", ready: "Дайын", signing : "Қол қою", },
      ncaMissing: "NCALayer табылмады. Бағдарламаны іске қосыңыз.",
      pdfNotReady: "Алдымен PDF түрлендіру қажет",
      pdfNotFound: "❌ PDF табылмады",
      signedOk: "✅ Қол қойылды",
      genericError: "Қате",
    },
    ru: {
      title: "Просмотр договора",
      expert: "Эксперт",
      status: "Статус",
      signedStatus: "✅ Подписано",
      pendingStatus: "⏳ Ожидается",
      signFlow: "Порядок подписания",
      contractNumber: "Номер договора:",
      date: "Дата:",
      save: "Сохранить номер и дату",
      sign: "Подписать (ЭЦП)",
      previewPdf: "Посмотреть PDF",
      download: "Скачать документ (DOCX)",
      error: "❌ Ошибка при сохранении номера",
      downloadError: "❌ Ошибка при загрузке документа",
      applicationsTitle: "📚 Заявки",
      roles: {
        internal_expert: "internal_expert",
        department_head: "department_supervisor",
        deputy_director_2: "Заместитель директора",
        registrar: "moderator_registrar",
        accountant: "moderator_accountant",
        director: "Директор",
        external_expert: "external_expert",
        goszakup: "Специалист по moderator_procurementкам",
      },
      tableHeaders: { role: "Роль", user: "Пользователь", status: "Статус", date: "Дата" },
      statusValues: { draft: "Черновик", signed: "Подписан", rejected: "Отклонён", in_progress: "В процессе", ready: "Готово",signing: "Подпись", },
      ncaMissing: "NCALayer не найден. Запустите приложение.",
      pdfNotReady: "Сначала нужно конвертировать в PDF",
      pdfNotFound: "❌ PDF не найден",
      signedOk: "✅ Подписано",
      genericError: "Ошибка",
    },
  }[locale];
  /* ================= helpers & hooks (до любых return!) ================= */
  const norm = (v) => String(v ?? "").trim().toLowerCase();

  const [ncaModalOpen, setNcaModalOpen] = useState(false);
const pendingSignRef = useRef(false);


  const isRegistrar = useMemo(() => {
    const name = norm(profile?.role?.name || profile?.role?.key);
    return name.includes("регист") || name.includes("registr") || name.includes("тірке");
  }, [profile]);

  const pdfReady = Boolean(
    selectedContract?.pdf_path ||
    selectedContract?.pdf_url ||
    selectedContract?.converted_at
  );

  const myPendingTurn = useMemo(() => {
    const me = (selectedContract?.signatures || []).find(
      (s) => Number(s.user_id) === Number(profile?.id)
    );
    return Boolean(me && !me.signed_at);
  }, [selectedContract, profile]);

  const hideRoleCol = norm(profile?.role?.name) === "internal_expert";
  const hideUserCol = norm(profile?.role?.name) === "external_expert";
  const roleTitle = (r) => t.roles?.[r] || r;

  /* ================= early return ниже хуков ================= */
  if (!selectedContract) return null;

  /* ================= actions ================= */
  const handleAssignNumber = async () => {
    try {
      const body = {
        contract_number: selectedContract.contract_number_input,
        contract_date: selectedContract.contract_date_input,
      };
      await axios.post(
        `/contracts/${selectedContract.id}/assign-number`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await openContractView(selectedContract.id);
    } catch (err) {
      alert(err?.response?.data?.message || t.error);
    }
  };

  const handlePreviewPdf = async () => {
    try {
      if (!pdfReady) {
        alert(t.pdfNotReady);
        return;
      }
      const res = await axios.get(`/contracts/${selectedContract.id}/pdf-base64`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const b64 = res?.data?.base64 || res?.data?.data || res?.data;
      if (!b64) {
        alert(t.pdfNotFound);
        return;
      }
      const pdfUrl = `data:application/pdf;base64,${b64}`;
      const win = window.open();
      if (win) {
        win.document.write(
          `<iframe src="${pdfUrl}" frameborder="0" style="position:fixed;inset:0;width:100%;height:100%"></iframe>`
        );
      } else {
        const a = document.createElement("a");
        a.href = pdfUrl;
        a.target = "_blank";
        a.rel = "noopener";
        a.click();
      }
    } catch (err) {
      alert(err?.response?.data?.message || t.genericError);
    }
  };

  const handleSign = async () => {
  if (!pdfReady) {
    alert(t.pdfNotReady);
    return;
  }

  const ok = await ensureNCALayerConnected({ connectTimeoutMs: 1200 });
  if (!ok) {
    pendingSignRef.current = true;
    setNcaModalOpen(true);
    return;
  }

  try {
    const pdfRes = await axios.get(
      `/contracts/${selectedContract.id}/pdf-base64`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const base64File =
      pdfRes?.data?.base64 || pdfRes?.data?.data || pdfRes?.data;

    if (!base64File) {
      alert(t.pdfNotFound);
      return;
    }

    window.blockScreen?.();
   window.NCA.createCMSSignatureFromBase64(
      "PKCS12",
      "SIGNATURE",
      base64File,
      true,
      async (result) => {
        window.unblockScreen?.();

        const code = result?.getCode ? result.getCode() : result?.code;
        if (String(code) !== "200") {
          alert(
            locale === "kz"
              ? "❌ ЭЦҚ арқылы қол қою қате орындалды"
              : "❌ Подпись ЭЦП выполнена неправильно"
          );
          return;
        }

        const signed_pdf_base64 =
          result?.getResponseObject?.() || result?.responseObject;

        await axios.post(
          `/contracts/${selectedContract.id}/sign`,
          { signed_pdf_base64 },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        alert(t.signedOk);
        await openContractView(selectedContract.id);
      }
    );
  } catch (err) {
    alert(err?.response?.data?.message || t.genericError);
  }
};


  const handleDownloadDocx = async () => {
    try {
      const res = await axios.get(`/contracts/${selectedContract.id}/download`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `contract_${selectedContract.id}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert(t.downloadError + ": " + (err?.response?.data?.message || t.genericError));
    }
  };

  /* ================= render ================= */
  return (
    <div
      className="vcm-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="vcm-title"
      onClick={(e) => e.target.classList.contains("vcm-modal") && onClose?.()}
    >
      <div className="vcm-backdrop" />
      <div className="vcm-dialog" role="document">
        {/* Header */}
        <header className="vcm-header">
          <h3 id="vcm-title" className="vcm-title">📄 {t.title}</h3>
          <button
            type="button"
            className="vcm-close vcm-close--x"
            aria-label={locale === "kz" ? "Жабу" : "Закрыть"}
            onClick={onClose}
          />
        </header>

        {/* Body */}
        <div className="vcm-body">
          {/* Contract Info */}
          <section className="vcm-info">
            <p>
              <strong>{t.expert}</strong>{" "}
              {selectedContract.external_expert?.name || selectedContract.external_expert_name || "—"}
            </p>
            <p>
              <strong>{t.status}</strong>{" "}
              {t.statusValues[selectedContract.status] || selectedContract.status}
            </p>
          </section>

          <section className="vcm-grid">
            {/* Applications */}
            <div className="vcm-apps">
              <h4 className="vcm-subtitle">{t.applicationsTitle}</h4>
              <ul className="vcm-apps-list">
                {(selectedContract.applications || []).map((app, idx) => (
                  <li key={idx} className="vcm-apps-item">🟦 {app.title}</li>
                ))}
              </ul>
            </div>

            {/* Signature flow */}
            <div className="vcm-sig">
              <h4 className="vcm-subtitle">✍️ {t.signFlow}</h4>
              <table className="vcm-table">
                <thead>
                  <tr>
                    {!hideRoleCol && <th className="vcm-th">{t.tableHeaders.role}</th>}
                    {!hideUserCol && <th className="vcm-th">{t.tableHeaders.user}</th>}
                    <th className="vcm-th">{t.tableHeaders.status}</th>
                    <th className="vcm-th">{t.tableHeaders.date}</th>
                  </tr>
                </thead>
                <tbody>
                  {(selectedContract.signatures || []).map((s, i) => (
                    <tr key={i}>
                      {!hideRoleCol && <td className="vcm-td">{roleTitle(s.role)}</td>}
                      {!hideUserCol && <td className="vcm-td">{s.user?.name || "—"}</td>}
                      <td className={`vcm-td ${s.signed_at ? "vcm-ok" : "vcm-warn"}`}>
                        {s.signed_at ? t.signedStatus : t.pendingStatus}
                      </td>
                      <td className="vcm-td">{s.signed_at || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {/* Assign number (registrar) */}
          {selectedContract.status === "in_progress" &&
            isRegistrar &&
            !selectedContract.contract_number && (
              <section className="vcm-assignment">
                <label className="vcm-label">📎 {t.contractNumber}</label>
                <input
                  className="vcm-input"
                  type="text"
                  value={selectedContract.contract_number_input || ""}
                  onChange={(e) =>
                    setSelectedContract((prev) => ({
                      ...prev,
                      contract_number_input: e.target.value,
                    }))
                  }
                />

                <label className="vcm-label">📅 {t.date}</label>
                <input
                  className="vcm-input"
                  type="date"
                  value={selectedContract.contract_date_input || ""}
                  onChange={(e) =>
                    setSelectedContract((prev) => ({
                      ...prev,
                      contract_date_input: e.target.value,
                    }))
                  }
                />

                <button className="vcm-btn vcm-btn--primary" onClick={handleAssignNumber}>
                  ✅ {t.save}
                </button>
              </section>
            )}
        </div>

        {/* Footer Actions */}
        <footer className="vcm-footer">
          {myPendingTurn && (
            <button
              className="vcm-btn vcm-btn--primary"
              onClick={handleSign}
              disabled={!pdfReady}
              title={!pdfReady ? t.pdfNotReady : ""}
            >
              {t.sign}
            </button>
          )}

          <button className="vcm-btn vcm-btn--secondary" onClick={handlePreviewPdf}>
            {t.previewPdf}
          </button>

          <button className="vcm-btn vcm-btn--secondary" onClick={handleDownloadDocx}>
            {t.download}
          </button>
        </footer>
      </div>

      <NCALayerModal
  open={ncaModalOpen}
  locale={locale}
  onClose={() => {
    setNcaModalOpen(false);
    pendingSignRef.current = false;
  }}
  onRetry={async () => {
    const ok = await ensureNCALayerConnected({ connectTimeoutMs: 1200 });
    if (!ok) return;

    setNcaModalOpen(false);

    if (pendingSignRef.current) {
      pendingSignRef.current = false;
      handleSign();
    }
  }}
/>

    </div>
  );
}
